import React from 'react'
import ReactDOM from 'react-dom/client'
import AuthContext from './Context/AuthContext'
import RequestContext from './Context/RequestContext'
import { ToastContainer } from 'react-toastify';
import Router from './Router/Router'
import 'bootstrap/dist/css/bootstrap.rtl.min.css'
import 'react-toastify/dist/ReactToastify.css';
import './assets/global.scss'
export const numberFormat = (value) => {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <AuthContext>
    <RequestContext>
      <Router />
      <ToastContainer position='bottom-center' theme='colored' />
    </RequestContext>
  </AuthContext>
)
